var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenEnvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 26.4844V6.51562L4.5 8.01562L6 6.51562L7.5 8.01562L9 6.51562L10.5 8.01562L12 6.51562L13.5 8.01562L15 6.51562L16.5 8.01562L18 6.51562L19.5 8.01562L21 6.51562V26.4844L19.5 24.9844L18 26.4844L16.5 24.9844L15 26.4844L13.5 24.9844L12 26.4844L10.5 24.9844L9 26.4844L7.5 24.9844L6 26.4844L4.5 24.9844L3 26.4844ZM18 13.5V11.4844H6V13.5H18ZM18 17.4844V15.5156H6V17.4844H18ZM18 21.5156V19.5H6V21.5156H18Z",
    fill: "#001574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEnvoice);
export default __webpack_public_path__ + "static/media/openEnvoice.84b9a11f615d9a1ffe541dd57208cb74.svg";
export { ForwardRef as ReactComponent };